var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { ODWebUtils } from '../../utils';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  padding: ", "\n    ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  padding: ", "\n    ", ";\n"])), function (p) { return p.bg_color; }, function (p) { return p.border_radius; }, function (p) { return ODWebUtils.addPostfixIfNumber(p.padding_td || 0, 'px'); }, function (p) { return ODWebUtils.addPostfixIfNumber(p.padding_lr || 0, 'px'); });
export var ODPillbox = function (props) {
    var style = props.style, children = props.children, pbProps = __rest(props, ["style", "children"]);
    return (React.createElement(Wrapper, __assign({}, pbProps, { style: style }), children));
};
var templateObject_1;
//# sourceMappingURL=ODPillbox.js.map